import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {CanDeactivateGuard} from './common/can-deactivate.guard';
import {AuthModule} from './components/auth';
import {AuthGuard} from './components/auth/auth.guard';
import {clientAuthGuard} from './components/auth/client-auth.guard';
import {UserRole} from './enums/user-role';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from './models/route-redirects';
import {NoContentPageComponent} from './pages/no-content-page';

// Must be exported in order to be used in providers.
export const REDIRECT_ROUTES: RouteRedirects = {
    LOGIN_ROUTE:      '/login',
    DASHBOARD_ROUTES: {
        [UserRole.TRADER]:       '/',
        [UserRole.ADMIN]:        '',
        [UserRole.TRADER_ADMIN]: '/'
    },
    GUEST_START_PAGE: '/'
};

const ROUTES: Routes = [
    {
        path:         'widget/:encodedWidgetsSettings',
        loadChildren: () => import('./pages/widget-page/widget-page.module').then(m => m.WidgetPageModule),
        canMatch:     [clientAuthGuard] // TODO: Handle BO case
    },
    {
        path:         '',
        loadChildren: () => import('./pages/dashboard/dashboard-page.module').then(m => m.DashboardPageModule),
        canActivate:  [clientAuthGuard]
    },
    {
        path:        '**',
        component:   NoContentPageComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports:   [
        RouterModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules}),
        AuthModule
    ],
    providers: [
        {
            provide:  ROUTE_REDIRECTS_TOKEN,
            useValue: REDIRECT_ROUTES
        },
        CanDeactivateGuard
    ],
    exports:   [
        RouterModule
    ]
})
export class AppRoutingModule {}
